import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ScGridTable from "../../../components/display/table/gridTableCore";
import FormCore from "../../../components/display/form/formCore";
import monthPickerHoc from "../../../hoc/form/monthPickerHoc";
import { getStubInfoListAll, prefixFile } from "../../../fetch/fetchApi";
// 国际化切换语言

const defaultDate = moment();

@monthPickerHoc
// eslint-disable-next-line arrow-parens
@connect((state) => state)
class chooseStubId extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.chooseStubId;
    this.state = {
      gridData: [],
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      page: 1,
    };

    // 判断初始日期是否再同一个月分
    const month1 = moment(new Date()).subtract(7, "d").format("MM");
    const month2 = moment(new Date()).format("MM");
    this.dateFlag = parseInt(month2) - parseInt(month1) > 0;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  init() {
    const momentFirst = moment(`${moment(new Date()).format("YYYY-MM")}-01`);
    this.formConfig = {
      childItems: [
        //     {
        //     width: '100%',
        //     param: {
        //         name: 'month',
        //         type: 'object'
        //     },
        //     defaultValue: moment(new Date(), 'YYYY-MM'),
        //     required: !1,
        //     labelName: this.internationalization.title1,//'月份选择',
        //     format: this.props.format,
        //     plugin: this.props.monthPicker[0](this.internationalization.title1, 'month')
        //  },
        // {
        //   type: "date",
        //   dateType: "rangeDate",
        //   placeholder: ["开始时间", "结束时间"],
        //   param: {
        //     name: "date",
        //     type: "array",
        //   },
        //   width: "240px",
        //   allowClear: false,
        //   defaultValue: [momentFirst, moment(new Date())],
        //   validator: { // 日期自定义校验规则
        //     vtype: "date", // 校验名称
        //     range: 0,
        //     max_val:365,
        //     notOverYear: true,
        //   }, // 自定义校验规则
        //   labelName: "起止日期", // '订单结束时间:',
        //   required: !0,
        // },
        {
          type: "input",
          placeholder: "设备编号",
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: "设备编号", // '设备编号:',
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              text: this.internationalization.btn1, // '查询',
              // icon: 'search'
            },
          ],
        },
      ], // 设置表单元素
      layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        startTime: momentFirst.format("YYYYMMDD"),
        endTime: moment(new Date()).format("YYYYMMDD"),
      },
      autoLoadGrid: !0, // 设置为false不触发加载grid
      context: this,
      tableKey: "moduleStatusLog",
    };
    this.setState({
      tableConfig: {
        tableColumns: [
          {
            name: "设备编号", // '电站名称',
            key: "key",
            colType: "textCol",
            tipNum: 30,
          },

          {
            name: "操作",
            key: "action",
            colType: "action", // 操作列，可定义多种操作。
            actionMap: [
              {
                type: "href",
                actionName: "选择",
                handler: (res) => {
                  console.info("啎");
                  console.info(this.props.chooseAc);
                  this.props.chooseAc(res);
                },
              },
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pageCount: 10,
        },
        tableInfo: {
          hasRow: !1, // 是否显示checkbox
        },
        autoRefresh: !1, // 设置为true 直接加载grid数据
        dataApi: getStubInfoListAll,
        tableKey: "moduleStatusLog",
      },
    });
  }

  fetchApi = (params) => {
    let result = {
      ...params,
    };
    return result;
  };

  handleOrderDetailModalCancel = () => {
    this.setState({
      orderDetailVisible: false,
    });
  };

  render() {
    return (
      <div className="sc-page-content">
        <FormCore
          formConfig={this.formConfig}
          getInstance={this.props.getInstance}
          fetchApi={this.fetchApi}
        />
        <div className="page-panel no-table-footer" style={{ marginTop: 15 }}>
          <ScGridTable config={this.state.tableConfig} unTotalMode />
        </div>
      </div>
    );
  }
}

export default injectIntl(chooseStubId);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/chooseStubId.js